/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateOldDimensionDto,
  DeleteOldDimensionDto,
  OldDimensionDto,
  UpdateOldDimensionDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class OldDimensionController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags old-dimension-controller
   * @name GetOldOrganisationDimensionAliases
   * @request GET:/api/v1/old/dimension
   */
  getOldOrganisationDimensionAliases = (params: RequestParams = {}) =>
    this.http.request<OldDimensionDto[], any>({
      path: `/v1/old/dimension`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOldOrganisationDimensionAliasesPath = '/v1/old/dimension'
  static getOldOrganisationDimensionAliasesMethod = 'GET'
  /**
   * No description
   *
   * @tags old-dimension-controller
   * @name UpdateOldDimensionAlias
   * @request PUT:/api/v1/old/dimension
   */
  updateOldDimensionAlias = (data: UpdateOldDimensionDto, params: RequestParams = {}) =>
    this.http.request<OldDimensionDto, any>({
      path: `/v1/old/dimension`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOldDimensionAliasPath = '/v1/old/dimension'
  static updateOldDimensionAliasMethod = 'PUT'
  /**
   * No description
   *
   * @tags old-dimension-controller
   * @name CreateOldDimensionAlias
   * @request POST:/api/v1/old/dimension
   */
  createOldDimensionAlias = (data: CreateOldDimensionDto, params: RequestParams = {}) =>
    this.http.request<OldDimensionDto, any>({
      path: `/v1/old/dimension`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOldDimensionAliasPath = '/v1/old/dimension'
  static createOldDimensionAliasMethod = 'POST'
  /**
   * No description
   *
   * @tags old-dimension-controller
   * @name DeleteOldDimensionAlias
   * @request DELETE:/api/v1/old/dimension
   */
  deleteOldDimensionAlias = (data: DeleteOldDimensionDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/old/dimension`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static deleteOldDimensionAliasPath = '/v1/old/dimension'
  static deleteOldDimensionAliasMethod = 'DELETE'
}
